import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface GenerateConfigurationSchemaFromFunctionResponse {
  schema: string;
}

export function useGenerateConfigurationSchemaFromFunction() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      agentUuid,
      variableName,
    }: {
      agentUuid: string;
      variableName: string;
    }): Promise<GenerateConfigurationSchemaFromFunctionResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/generate_configuration_schema_from_function`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid, variableName }),
        }
      );

      const data = await response.json();

      return {
        schema: data?.data?.schema,
      };
    },
  });
}
